/**
 * Decide what (if anything) should run after a parameter Reset.
 *
 * Resetting a parameter value must behave like a manual value change with
 * respect to auto-run / auto-cascading. `App.onValueChange` already encodes
 * this: when auto-run is on it runs the dashboard, otherwise when
 * "Update Other Parameter Values" (isAutoCascading) is on it triggers a
 * cascading-parameter update only. The reset paths previously handled only the
 * auto-run case, so resetting with auto-run off never refreshed cascading
 * parameters. tam#36882
 *
 * Extracted as a pure helper so the decision is unit-testable without mounting
 * the React component.
 *
 * @param {Object} state - The App state (or a subset).
 * @param {boolean} state.isAutoRun - Whether auto-run is enabled.
 * @param {boolean} state.isAutoCascading - Whether "Update Other Parameter Values" is on.
 * @returns {'run'|'cascade'|'none'}
 *   'run'     - run the dashboard (auto-run).
 *   'cascade' - update cascading parameters only (auto-run off, auto-cascading on).
 *   'none'    - do nothing.
 */
export function computeResetRunAction(state) {
  if (state && state.isAutoRun) {
    return 'run';
  }
  if (state && state.isAutoCascading) {
    return 'cascade';
  }
  return 'none';
}
